/**
 * Biologie médicale — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: LAB
 * Catalogue acts (NGAP Maroc): 234
 */
import { defineSpecialty } from "../types";

export const biologie = defineSpecialty(
{
  "id": "biologie",
  "label": "Biologie médicale",
  "short": "Biologie",
  "scope": "Analyses de laboratoire",
  "aliases": [
    "LAB"
  ],
  "doctorSpecs": [
    "Biologie médicale"
  ],
  "featureFlag": "ux.v2.biologie",
  "theme": {
    "primary": "oklch(0.72 0.17 150)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "worklist",
      "label": "Worklist",
      "icon": "ListChecks",
      "route": "/clinical/worklist",
      "order": 1,
      "requires": [
        "lims"
      ]
    },
    {
      "id": "results",
      "label": "Résultats",
      "icon": "FlaskConical",
      "route": "/clinical/lab",
      "order": 2,
      "requires": []
    },
    {
      "id": "validation",
      "label": "Validation",
      "icon": "CheckCircle2",
      "route": "/clinical/validation",
      "order": 3,
      "requires": []
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 4,
      "requires": [
        "pacs"
      ]
    }
  ],
  "panels": [
    {
      "id": "results",
      "label": "Résultats",
      "icon": "FlaskConical",
      "component": "LabResultsGrid",
      "order": 1,
      "requires": []
    },
    {
      "id": "validation",
      "label": "Validation",
      "icon": "CheckCircle2",
      "component": "ValidationQueue",
      "order": 2,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Biologie médicale",
    "subSpecialties": [
      "Biologie",
      "Hématologie",
      "Biochimie",
      "Microbiologie",
      "Parasitologie"
    ],
    "catalogueActs": 234
  },
  "terminology": {
    "icd10": [
      "R00",
      "R50",
      "R87"
    ],
    "loinc": [
      "58410-2",
      "718-7",
      "2345-7"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "hematology-analyzer",
    "chemistry-analyzer",
    "coagulometer"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default biologie;
